export const TERMS_OF_USE_LINKS = {
  en: 'https://corp.narvar.com/termsofservice/',
  ja: 'https://corp.narvar.com/jp/terms/',
};
export const PRIVACY_LINKS = {
  en: 'https://corp.narvar.com/privacy-policy/',
  ja: 'https://corp.narvar.com/jp/terms-of-service',
};
